// src/helpers/formatters.js

export const formatNumber = (value) => {
  if (isNaN(value)) return value;
  return new Intl.NumberFormat("es-PE").format(value);
};

export const formatPercentage = (value, decimals = 2) => {
  if (isNaN(value)) return value;
  return `${Number(value).toFixed(decimals)}%`;
};

export const formatCurrency = (value, currency = "PEN") => {
  if (isNaN(value)) return value;
  return new Intl.NumberFormat("es-PE", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};
